import { EQueryOperators, EQueryTypes, FilterableQuery, StandardError, TComplexCondition, TSimpleCondition } from "ecloud-base-connector";

export class Request extends FilterableQuery {
	private orderBy: { field: string, type: string }[] = [];
	private limit: number | null;

	// Constructor needed for type extension limitation. Not used
	constructor(modelName: string) {
		super(EQueryTypes.select, modelName);
	}

	getQueryData() {
		return this.compileQuery().queryData;
	}

	// queryString needed for type extension limitation. Not used
	compileQuery(): { queryString: string, queryData: any } {
		const queryParams: { search?: any, limit?: number, sort?: string[] } = {};

		const compiledFilters = this.compileFilters();
		const compiledLimit = this.compileLimitData();
		const compiledOrderBy = this.compileOrderByData();

		if (compiledFilters.length)
			queryParams.search = JSON.stringify(compiledFilters);
		if (compiledLimit)
			queryParams.limit = compiledLimit;
		if (compiledOrderBy.length)
			queryParams.sort = compiledOrderBy;

		return { queryString: "", queryData: queryParams };
	}

	//#region Add sections to query

	public addOrderBy(orderField: string, orderType?: "ASC" | "DESC") {
		if (this.checkAddOrderBy(orderField, orderType))
			this.prepareOrderBy(orderField, orderType);
		return this;
	}

	public addLimit(limit: number) {
		if (this.checkAddLimit(limit))
			this.prepareLimit(limit);
		return this;
	}

	//#endregion

	//#region Validate added regions of query

	private checkAddOrderBy(orderField: string, orderType?: "ASC" | "DESC") {
		return true;
	}

	private checkAddLimit(limit1: number) {
		if (limit1 < 0)
			throw new StandardError(null, `Lower limit (${limit1}) must be greater than 0`);
		return true;
	}

	//#endregion

	//#region Prepare added sections

	private prepareOrderBy(orderField: string, orderType?: "ASC" | "DESC") {
		this.orderBy.push({ field: orderField, type: orderType || "ASC" });
		return this;
	}

	private prepareLimit(limitSize: number) {
		this.limit = limitSize;
		return this;
	}

	//#endregion

	//#region Compile added sections

	protected compileFilters(): any {
		if (!this.fieldFilters.length)
			return [];
		return this.compileQueryFilter(this.fieldFilters);
	}

	protected compileQueryFilter(queryFilters: any[]): any {
		const formattedLineFilters = queryFilters.map(lineFilter => this.compileLineFilter(lineFilter));

		return formattedLineFilters.length > 1 ? ["AND", ...formattedLineFilters] : formattedLineFilters[0];
	}

	protected compileLineFilter(lineFilters: { [fieldName: string]: any }): any {
		const formattedFieldConditions = Object.entries(lineFilters).map(([fieldName, conditions]) => this.compileFieldConditions(fieldName, conditions));

		return formattedFieldConditions.length > 1 ? ["OR", ...formattedFieldConditions] : formattedFieldConditions[0];
	}

	protected compileFieldConditions(fieldName: string, conditions: (TSimpleCondition | TComplexCondition)[]): any {
		const formattedConditions = conditions.map(condition => this.compileConditions(fieldName, condition));

		return formattedConditions.length > 1 ? ["OR", ...formattedConditions] : formattedConditions[0];
	}

	protected compileConditions(fieldName: string, condition: TSimpleCondition | TComplexCondition): any {
		let operator: string;
		const [condKey, condValue] = Object.entries(condition)[0];
		switch (condKey) {
			case "eq":
			case "neq":
			case "like":
			case "notlike":
			case "gt":
			case "lt":
			case "gteq":
			case "lteq":
			case "in":
			case "notin":
				operator = EQueryOperators[condKey];
				return [fieldName, operator, condValue];
			case "notnull":
				operator = EQueryOperators["neq"];
				return [fieldName, operator, "null"];
			case "null":
				operator = EQueryOperators["eq"];
				return [fieldName, operator, "null"];
			default:
				return [];
		}
	}

	protected compileOrderByData() {
		return this.orderBy.map(({ field, type }) => {
			return `${field} ${type}`;
		});
	}

	protected compileLimitData() {
		return this.limit;
	}

	//#endregion
}